import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setNewDialogsFW } from "../../../../store/slices/dialogFormWidgetSlice";
import { HexAlphaColorPicker } from "react-colorful";
import styles from "./ColorPickersDWF.module.scss";
import "./ColorPickersDWF.css";

const ColorPickerItem = ({
  title,
  color,
  onChange,
  name,
  value,
  handlerInput,
}) => {
  return (
    <div className={styles.colorPickerItem}>
      <div className={styles.colorPickerTitleS}>{title}</div>
      <div className="customLayoutPicker">
        <HexAlphaColorPicker color={color} onChange={onChange} />
      </div>
      <div className={styles.colorPickerValuesContainer}>
        <div className={styles.colorPickerInputContainer}>
          <div className={styles.colorPickerInputTitle}>HEX:</div>
          <input
            className={styles.colorPickerInput}
            name={name}
            value={value}
            onChange={handlerInput}
          />
        </div>
      </div>
    </div>
  );
};

export const ColorPickersDWF = () => {
  const dispatch = useDispatch();

  const { newDialogFormWidget } = useSelector((state) => state?.dialogWF);

  const handleColorChange = (color, type) => {
    if (newDialogFormWidget) {
      const updatedDFW = { ...newDialogFormWidget, [type]: color };
      dispatch(setNewDialogsFW(updatedDFW));
    }
  };

  const handlerInput = (e) => {
    if (newDialogFormWidget) {
      let res = JSON.parse(JSON.stringify(newDialogFormWidget));

      Object.defineProperty(res, e.target.name, {
        value: e.target.value,
      });

      dispatch(setNewDialogsFW(res));
    }
  };

  const rendererData = [
    {
      title: "Цвет фона",
      color: newDialogFormWidget ? newDialogFormWidget.widgetColor : "",
      onChange: (color) => handleColorChange(color, "widgetColor"),
      name: "widgetColor",
      value: newDialogFormWidget ? newDialogFormWidget.widgetColor : "",
    },
    {
      title: "Цвет текста",
      color: newDialogFormWidget ? newDialogFormWidget.widgetTextColor : "",
      onChange: (color) => handleColorChange(color, "widgetTextColor"),
      name: "widgetTextColor",
      value: newDialogFormWidget ? newDialogFormWidget.widgetTextColor : "",
    },
    {
      title: "Цвет обводки",
      color: newDialogFormWidget ? newDialogFormWidget.widgetBorderColor : "",
      onChange: (color) => handleColorChange(color, "widgetBorderColor"),
      name: "widgetBorderColor",
      value: newDialogFormWidget ? newDialogFormWidget.widgetBorderColor : "",
    },
    {
      title: "Цвет поля ввода",
      color: newDialogFormWidget ? newDialogFormWidget.widgetInputColor : "",
      onChange: (color) => handleColorChange(color, "widgetInputColor"),
      name: "widgetInputColor",
      value: newDialogFormWidget ? newDialogFormWidget.widgetInputColor : "",
    },
    {
      title: 'Цвет кнопки "Отправить"',
      color: newDialogFormWidget ? newDialogFormWidget.widgetButtonColor : "",
      onChange: (color) => handleColorChange(color, "widgetButtonColor"),
      name: "widgetButtonColor",
      value: newDialogFormWidget ? newDialogFormWidget.widgetButtonColor : "",
    },
    {
      title: "Цвет заблокированной кнопки",
      color: newDialogFormWidget
        ? newDialogFormWidget.widgetButtonDisabledColor
        : "",
      onChange: (color) =>
        handleColorChange(color, "widgetButtonDisabledColor"),
      name: "widgetButtonDisabledColor",
      value: newDialogFormWidget
        ? newDialogFormWidget.widgetButtonDisabledColor
        : "",
    },
  ];

  return (
    <div className={styles.colorPicker}>
      <div className={styles.colorPickerTitle}>Выберите цвета для формы</div>
      <div className={styles.colorPickerItemContainer}>
        {rendererData.map((item, index) => (
          <ColorPickerItem
            title={item.title}
            color={item.color}
            onChange={item.onChange}
            name={item.name}
            value={item.value}
            handlerInput={handlerInput}
          />
        ))}
      </div>
    </div>
  );
};
